import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "components/UI";
import { useChurchStore } from "features/churches";
import { useBanksPaginated, useBankStore } from "features/finances";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  grid-column: 2 / 3;
  grid-row: 1 / 3;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Title = styled.h6`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
`;

const PrimaryActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const BankTable = ({ onboarding }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const openCreateBankAccountModal = useBankStore(
    state => state.openCreateBankAccountModal
  );
  const openUpdateBankAccountModal = useBankStore(
    state => state.openUpdateBankAccountModal
  );
  const setSelectedBank = useBankStore(state => state.setSelectedBank);
  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const banksQuery = useBanksPaginated({
    churchId: selectedChurch?.id,
    page,
    pageSize
  });

  const columns = [
    {
      field: "name",
      headerName: "Bank Name",
      flex: 1
    },
    {
      field: "account_number",
      headerName: "Account Number",
      flex: 1
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1
    }
  ];

  return (
    <Container>
      {!onboarding && (
        <Stack alignItems="flex-start" spacing={4}>
          <Header>
            <Title>Bank Table</Title>
            <PrimaryActions>
              <Button onClick={openCreateBankAccountModal}>
                Create Bank Account
              </Button>
            </PrimaryActions>
          </Header>
        </Stack>
      )}
      <DataGrid
        autoHeight
        rows={banksQuery.data?.result?.data || []}
        rowCount={banksQuery.data?.result?.total || 0}
        loading={banksQuery?.isLoading}
        columns={columns}
        pagination
        rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
        density="comfortable"
        getRowId={row => row.id}
        disableColumnMenu
        disableSelectionOnClick
        paginationMode="server"
        page={page - 1}
        pageSize={pageSize}
        onPageChange={newPage => setPage(newPage + 1)}
        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        onRowClick={({ row }) => {
          if (onboarding) return;

          setSelectedBank(row);
          openUpdateBankAccountModal();
        }}
        localeText={{
          noRowsLabel: t("teams.teamProfile.NoRows"),
          MuiTablePagination: {
            labelRowsPerPage: t("teams.teamProfile.RowsPerPage")
          }
        }}
      />
    </Container>
  );
};
